export default "__VITE_ASSET__1643ca23__"